var map = {
	"./audio-placeholder": 540,
	"./audio-placeholder.png": 540,
	"./avatar-missing": 505,
	"./avatar-missing.png": 505,
	"./avatar-missing.svg": 1020,
	"./halloween/clouds": 541,
	"./halloween/clouds.png": 541,
	"./halloween/halloween-emblem": 622,
	"./halloween/halloween-emblem.svg": 622,
	"./halloween/spider": 623,
	"./halloween/spider.svg": 623,
	"./halloween/spiderweb": 624,
	"./halloween/spiderweb.svg": 624,
	"./halloween/starfield": 625,
	"./halloween/starfield.png": 625,
	"./halloween/twinkle": 626,
	"./halloween/twinkle.svg": 626,
	"./header-missing": 506,
	"./header-missing.png": 506,
	"./soapbox-logo": 507,
	"./soapbox-logo-white": 508,
	"./soapbox-logo-white.svg": 508,
	"./soapbox-logo.svg": 507,
	"./sprite-post-functions": 630,
	"./sprite-post-functions.png": 630,
	"./video-placeholder": 641,
	"./video-placeholder.png": 641,
	"./void": 642,
	"./void.png": 642,
	"./web-push/web-push-icon_expand": 904,
	"./web-push/web-push-icon_expand.png": 904,
	"./web-push/web-push-icon_favourite": 905,
	"./web-push/web-push-icon_favourite.png": 905,
	"./web-push/web-push-icon_reblog": 906,
	"./web-push/web-push-icon_reblog.png": 906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1019;